import type { ListingDetails } from 'app/types/listingDetails.type';

export type QualifierVariant = 'studentHousing' | 'seniorHousing' | 'incomeRestricted';

type GetQualifierVariantArgs = {
  listing: ListingDetails;
  hasConversation?: boolean;
  satelliteEnabled?: boolean;
};

// Mirrors the legacy if/else chain in ContactOverlay.tsx so user-facing copy
// doesn't shift between apps. Limited to the three variants ported for HP-7631
// (student/senior/income). Waitlist and recently-contacted copy live in the
// form itself in HALO and are intentionally not duplicated here.
export function getQualifierVariant({
  listing,
  hasConversation = false,
  satelliteEnabled = false,
}: GetQualifierVariantArgs): QualifierVariant | null {
  if (hasConversation && satelliteEnabled) {
    return null;
  }

  if (listing.details?.studentHousing) {
    return 'studentHousing';
  }

  if (listing.details?.seniorHousing) {
    return 'seniorHousing';
  }

  if (listing.contact?.restricted) {
    return 'incomeRestricted';
  }

  return null;
}
